import styled from 'styled-components';
import { themeGet } from 'styled-system';
import { BaseLink, Card } from 'src/kit';

export const StyledContainer = styled(Card).attrs({ variant: 'primary' })`
  position: fixed;
  left: 5px;
  bottom: 5px;
  z-index: 3000;
  margin: 0;
  padding: 0;
  background: ${themeGet('colors.header.bg')};
  color: ${themeGet('colors.header.text')};

  > ${BaseLink} {
    padding: 5px 10px;
  }
`;
